import { UploadFile } from "@mui/icons-material";
import { Box, Card, CircularProgress, Grid, Icon, IconButton, InputLabel } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { useUser } from "context/UserContext";
import { Form, Formik } from 'formik';
import { memo, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { postUploadNoResponse } from "utils/WebService";
import * as Yup from 'yup';

const UploadArquivoIndice = ({ closeCreateEdit }) => {
    const [isLoadingUpload, setIsLoadingUpload] = useState(false);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const { tipoIndiceEnum } = useUser();


    const handleSubmit = (file, values, { setSubmitting }) => {
        if (!file) {
            errorAlert('Selecione um arquivo antes de enviar.');
            setSubmitting(false);
            return;
        }

        if (values.tipo == null) {
            errorAlert('Selecione um tipo de índice antes de enviar.');
            setSubmitting(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        postUploadNoResponse(`/indices/${values.tipo.code}/upload`, formData)
            .then(() => {
                successAlert("Upload realizado com sucesso.", handleSucess())
            }).catch((error) => {
                console.log(error)
                errorAlert('Erro ao enviar arquivo.');
            }).finally(() => {
                setSubmitting(false);
                setFileName(null);
                setFile(null);
            });
    };

    function handleSucess() {
        closeCreateEdit();
    }

    const onFileChange = async ({ target }) => {
        setIsLoadingUpload(true)
        const file = target.files[0];
        if (file) {
            setFileName(file.name);
            setFile(file);
            setIsLoadingUpload(false);
        }
    };


    return (
        <Card id="user-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h4">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h5">Upload Índice</MDTypography>
            </Box>
            <Formik
                initialValues={{
                    tipo: null,
                }}
                validationSchema={validationSchema}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(true);
                    handleSubmit(file, values, actions);
                }}
            >
                {({ values, setFieldValue, touched, errors, isSubmitting }) => {

                    return (
                        <Form id={configForm.formId} autoComplete="off">
                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={3}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                                            Tipo de Índice
                                        </InputLabel>
                                        <MDSelect
                                            isMulti={false}
                                            getOptionValue={option => option.code}
                                            getOptionLabel={option => option.name}
                                            name="tipo"
                                            placeholder="Selecione"
                                            value={values.tipo}
                                            options={tipoIndiceEnum}
                                            onChange={selectedOptions => {
                                                setFieldValue("tipo", selectedOptions);
                                            }}
                                        />
                                        {errors.tipo && touched.tipo && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.tipo}
                                            </MDTypography>
                                        )}
                                    </Grid>

                                    <Grid item xs={3}>
                                        <MDButton
                                            variant="contained"
                                            component="label"
                                            startIcon={(!isLoadingUpload && !fileName) && <UploadFile />}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                mt: 2,
                                                ml: 2,
                                                minWidth: 'auto',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '100%',
                                                paddingRight: fileName ? 2 : 4.5
                                            }}
                                            color="info"
                                            endIcon={isLoadingUpload ?
                                                <CircularProgress
                                                    color="white"
                                                    size={20} sx={{ ml: 0, mr: 0 }} /> : null}
                                        >
                                            {!isLoadingUpload &&
                                                <>
                                                    {!fileName && "Upload"}
                                                    <input
                                                        type="file"
                                                        accept=".txt"
                                                        onChange={(e) => {
                                                            onFileChange(e);
                                                        }}
                                                        hidden
                                                    />
                                                </>
                                            }
                                            {fileName && (
                                                <span style={{
                                                    marginLeft: '10px',
                                                    color: '#ffff',
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}>
                                                    {fileName}
                                                </span>
                                            )}
                                        </MDButton>
                                    </Grid>
                                </Grid>
                            </MDBox>
                            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                <MDButton
                                    size="large"
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    type="submit"
                                    endIcon={isSubmitting ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                                    {!isSubmitting && "Enviar"}
                                </MDButton>
                            </Box>
                        </Form>)
                }}
            </Formik>
        </Card>
    );
}

export default memo(UploadArquivoIndice);


export const configForm = {
    formId: "configuration-form",
    formField: {
        tipo: {
            name: "tipo",
            label: "Tipo",
            placeholder: "Selecione",
            errorMsg: "Campo Obrigatório.",
        },
    }
}

const {
    formField: {
        tipo,
    },
} = configForm;


export const validationSchema = Yup.object().shape({
    [tipo.name]: Yup.object()
        .required(tipo.errorMsg),
});
